import React, { useState, useEffect, useCallback } from 'react';
import Router from './Router';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import CookieConsentBanner from './Components/CookieConsentBanner';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './i18n';

const CONSENT_STORAGE_KEY = 'securepaper_cookie_consent';

// Analytics load only after the user consented in the cookie banner
const readAnalyticsConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return false;
    const consent = JSON.parse(raw);
    return !!(consent && consent.preferences && consent.preferences.analytics);
  } catch {
    return false;
  }
};

function App() {
  const [analyticsAllowed, setAnalyticsAllowed] = useState(readAnalyticsConsent);

  const refreshConsent = useCallback(() => {
    setAnalyticsAllowed(readAnalyticsConsent());
  }, []);

  useEffect(() => {
    window.addEventListener('securepaper-consent-changed', refreshConsent);
    return () => window.removeEventListener('securepaper-consent-changed', refreshConsent);
  }, [refreshConsent]);

  return (
    <LanguageProvider>
      <AuthProvider>
        <Router />
      </AuthProvider>
      <CookieConsentBanner />
      {analyticsAllowed && (
        <>
          <Analytics />
          <SpeedInsights />
        </>
      )}
    </LanguageProvider>
  );
}

export default App;
